import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import Login from '../components/onlinereg-app/auth/LoginComponent.vue'
import Home from '../components/onlinereg-app/home/HomeComponent.vue'
import Portal from '../components/onlinereg-app/home/PortalComponent.vue'
import Informasi from '../components/onlinereg-app/home/home-contents/Informasi.vue'
import JadwalDokter from '../components/onlinereg-app/home/home-contents/JadwalDokter.vue'

import KonfigurasiWebsite from '../components/onlinereg-app/home/portal-contents/website/KonfigurasiWebsite.vue'

import KonfigurasiUser from '../components/onlinereg-app/home/portal-contents/user/KonfigurasiUser.vue'
import EditUser from '../components/onlinereg-app/home/portal-contents/user/EditUser.vue'
import AddUser from '../components/onlinereg-app/home/portal-contents/user/AddUser.vue'

import KonfigurasiKuotaPoli from '../components/onlinereg-app/home/portal-contents/kuota-poli/KonfigurasiKuotaPoli.vue'
import EditKuotaPoli from '../components/onlinereg-app/home/portal-contents/kuota-poli/EditKuotaPoli.vue'
import AddKuotaPoli from '../components/onlinereg-app/home/portal-contents/kuota-poli/AddKuotaPoli.vue'

import Pendaftaran from '../components/onlinereg-app/home/home-contents/Pendaftaran.vue'

import KonfigurasiKategoriAntrean from '../components/onlinereg-app/home/portal-contents/kategori/KonfigurasiKategoriAntrean.vue'
import AddKategoriAntrean from '../components/onlinereg-app/home/portal-contents/kategori/AddKategoriAntrean.vue'

import KonfigurasiMasterLoket from '../components/onlinereg-app/home/portal-contents/master-loket/KonfigurasiMasterLoket.vue'
import AddMasterLoket from '../components/onlinereg-app/home/portal-contents/master-loket/AddMasterLoket.vue'
import EditMasterLoket from '../components/onlinereg-app/home/portal-contents/master-loket/EditMasterLoket.vue'

import KonfigurasiLoketPendaftaran from '../components/onlinereg-app/home/portal-contents/loket-pendaftaran/KonfigurasiLoketPendaftaran.vue'
import AddLoketPendaftaran from '../components/onlinereg-app/home/portal-contents/loket-pendaftaran/AddLoketPendaftaran.vue'
import EditLoketPendaftaran from '../components/onlinereg-app/home/portal-contents/loket-pendaftaran/EditLoketPendaftaran.vue'

import KonfigurasiLoketPendaftaranOnline from '../components/onlinereg-app/home/portal-contents/konfigurasi-loket-pendaftaran/KonfigurasiLoketPendaftaran.vue'
import EditKonfigurasiLoketPendaftaranOnline from '../components/onlinereg-app/home/portal-contents/konfigurasi-loket-pendaftaran/EditKonfigurasiLoketPendaftaran.vue'

import Pengumuman from '../components/onlinereg-app/home/home-contents/Pengumuman.vue'
import KonfigurasiPengumuman from '../components/onlinereg-app/home/portal-contents/pengumuman/KonfigurasiPengumuman.vue'
import AddPengumuman from '../components/onlinereg-app/home/portal-contents/pengumuman/AddPengumuman.vue'
import EditPengumuman from '../components/onlinereg-app/home/portal-contents/pengumuman/EditPengumuman.vue'

const routes = [
    {
        name: 'auth_signin',
        path: '/login',
        component: Login
    },
    {
        name: 'home',
        path: '/',
        component: Home
    },
    {
        name: 'portal',
        path: '/portal',
        component: Portal
    },
    {
        name: 'informasi',
        path: '/informasi',
        component: Informasi
    },
    {
        name: 'jadwal-dokter',
        path: '/jadwal-dokter',
        component: JadwalDokter
    },
    {
        name: 'konfigurasi-website',
        path: '/konfigurasi-website',
        component: KonfigurasiWebsite
    },
    {
        name: 'konfigurasi-user',
        path: '/konfigurasi-user',
        component: KonfigurasiUser
    },
    {
        name: 'edit-user',
        path: '/edit-user',
        component: EditUser,
        props: true
    },
    {
        name: 'add-user',
        path: '/add-user',
        component: AddUser,
    },
    {
        name: 'konfigurasi-kuota-poli',
        path: '/konfigurasi-kuota-poli',
        component: KonfigurasiKuotaPoli
    },
    {
        name: 'edit-konf-kuota-poli',
        path: '/edit-konf-kuota-poli',
        component: EditKuotaPoli,
        props: true
    },
    {
        name: 'add-konf-kuota-poli',
        path: '/add-konf-kuota-poli',
        component: AddKuotaPoli,
    },
    {
        name: 'pendaftaran',
        path: '/pendaftaran',
        component: Pendaftaran
    },
    {
        name: 'konfigurasi-kategori-antrean',
        path: '/konfigurasi-kategori-antrean',
        component: KonfigurasiKategoriAntrean
    },
    {
        name: 'add-kategori-antrean',
        path: '/add-kategori-antrean',
        component: AddKategoriAntrean
    },
    {
        name: 'konfigurasi-master-loket',
        path: '/konfigurasi-master-loket',
        component: KonfigurasiMasterLoket
    },
    {
        name: 'add-master-loket',
        path: '/add-master-loket',
        component: AddMasterLoket
    },
    {
        name: 'edit-master-loket',
        path: '/edit-master-loket',
        component: EditMasterLoket,
        props: true
    },
    {
        name: 'konfigurasi-loket-pendaftaran',
        path: '/konfigurasi-loket-pendaftaran',
        component: KonfigurasiLoketPendaftaran
    },
    {
        name: 'add-loket-pendaftaran',
        path: '/add-loket-pendaftaran',
        component: AddLoketPendaftaran
    },
    {
        name: 'edit-loket-pendaftaran',
        path: '/edit-loket-pendaftaran',
        component: EditLoketPendaftaran,
        props: true
    },
    {
        name: 'konfigurasi-loket-pendaftaran-online',
        path: '/konfigurasi-loket-pendaftaran-online',
        component: KonfigurasiLoketPendaftaranOnline,
    },
    {
        name: 'edit-konfigurasi-loket-pendaftaran-online',
        path: '/edit-konfigurasi-loket-pendaftaran-online',
        component: EditKonfigurasiLoketPendaftaranOnline,
        props: true
    },
    {
        name: 'pengumuman',
        path: '/pengumuman',
        component: Pengumuman
    },
    {
        name: 'konfigurasi-pengumuman',
        path: '/konfigurasi-pengumuman',
        component: KonfigurasiPengumuman
    },
    {
        name: 'add-pengumuman',
        path: '/add-pengumuman',
        component: AddPengumuman
    },
    {
        name: 'edit-pengumuman',
        path: '/edit-pengumuman',
        component: EditPengumuman,
        props: true
    }
]

const router = new VueRouter({
    mode: 'history',
    routes: routes,
    linkActiveClass: 'active'
})

export default router
